import {
  LatitudeLongitude,
  ToolkitProperty,
  getBathsString,
  isDefined,
} from '@aloft/toolkit-shared';
import { Units, distance, point } from '@turf/turf';

import { PLACEHOLDER } from './constants';
import { SystemAccessorTPColumnDefs } from './types';

export const systemAccessorTPColumnDefs: SystemAccessorTPColumnDefs = {
  distance: {
    title: 'Distance',
    selector: ({ latitude, longitude }) => ({
      latitude,
      longitude,
    }),
    toString: (value, subjectProperty) => {
      if (!isDefined(subjectProperty) || !isDefined(value)) return PLACEHOLDER;

      const { latitude, longitude } = value;
      if (!isDefined(latitude) || !isDefined(longitude)) return PLACEHOLDER;

      return getDistanceFromSubjectProperty({ latitude, longitude }, subjectProperty);
    },
    // TODO: Add sorting for distance column
    // sortBy: (a, b, subjectProperty) => {
    //     console.log('subjectProperty', subjectProperty);
    //     if (!isDefined(subjectProperty)) return 0;
    //     return getDistanceFromSubjectProperty(a, subjectProperty).localeCompare(
    //         getDistanceFromSubjectProperty(b, subjectProperty)
    //     );
    // },
  },
  baths: {
    title: 'Baths',
    selector: ({
      aboveGradeFullBathCount,
      aboveGradeHalfBathCount,
      aboveGradeThreeQuarterBathCount,
    }) => ({
      aboveGradeFullBathCount,
      aboveGradeHalfBathCount,
      aboveGradeThreeQuarterBathCount,
    }),
    toString: (value) => {
      if (!isDefined(value)) return PLACEHOLDER;
      return getBathsString(value);
    },

    sortBy: (a, b) => {
      const aBathString = getBathsString(a);
      const bBathString = getBathsString(b);

      return aBathString.localeCompare(bBathString);
    },
  },
};

function getDistanceFromSubjectProperty(
  { latitude, longitude }: Partial<LatitudeLongitude>,
  subjectProperty: ToolkitProperty,
): string {
  const subjectLongitude = subjectProperty.longitude;
  const subjectLatitude = subjectProperty.latitude;

  if (typeof subjectLatitude !== 'number' || typeof subjectLongitude !== 'number') {
    console.error(`Invalid subject property coordinates: ${subjectLongitude}, ${subjectLatitude}`);
    return ' '; // TODO make this an error if we ever move this to persist path
  }

  if (typeof latitude !== 'number' || typeof longitude !== 'number') {
    console.error(`Invalid property coordinates: ${longitude}, ${latitude}`);
    return ' '; // TODO make this an error if we ever move this to persist path
  }

  return getDistFrom(
    { latitude: subjectLatitude, longitude: subjectLongitude },
    { longitude, latitude },
  );
}

function getDistFrom(
  start: LatitudeLongitude,
  dest: LatitudeLongitude,
  units: Units = 'miles',
): string {
  const from = point([start.longitude, start.latitude]);
  const to = point([dest.longitude, dest.latitude]);
  const distanceInMiles = distance(from, to, { units }).toFixed(2);

  return distanceInMiles;
}
